import {
  useEffect,
  useState,
} from 'react';
/**
 * Hook to get responsive chart heights based on screen width
 * @returns {object} Object with different chart height values
 */
const useResponsiveChartHeight = () => {
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Small charts (IrrigationChart, RootsChart)
  const getMinionChartHeight = () => {
    if (screenHeight <= 800) return '100px';
    if (screenHeight <= 1000) return '100px';
    if (screenHeight <= 1200) return '100px';
    return '100px';
  };

  // Small charts (IrrigationChart, RootsChart)
  const getSmallChartHeight = () => {
    if (screenHeight <= 800) return '100px';
    if (screenHeight <= 1000) return '110px';
    if (screenHeight <= 1200) return '110px';
    return '110px';
  };

  // Medium charts (StackedSoilMoistureChart)
  const getMediumChartHeight = () => {
    if (screenHeight <= 800) return '160px';
    if (screenHeight <= 1000) return '210px';
    if (screenHeight <= 1200) return '15%';
    return '15%';
  };

  // Large charts (SoilMoistureChart, PlantsChart)
  const getLargeChartHeight = () => {
    if (screenHeight <= 800) return '230px';
    if (screenHeight <= 1000) return '260px';
    if (screenHeight <= 1200) return '20%';
    return '20%';
  };

  // Large charts (SoilMoistureChart, PlantsChart)
  const getXLargeChartHeight = () => {
    if (screenHeight <= 800) return '270px';
    if (screenHeight <= 1000) return '310px';
    if (screenHeight <= 1200) return '30%';
    return '30%';
  };

  return {
    minionChartHeight: getMinionChartHeight(),
    smallChartHeight: getSmallChartHeight(),
    mediumChartHeight: getMediumChartHeight(),
    largeChartHeight: getLargeChartHeight(),
    xLargeChartHeight: getXLargeChartHeight(),
  };
};

export default useResponsiveChartHeight;
